import { chakra, HTMLChakraProps } from '@chakra-ui/react'

// #222222 -> #F0F0F0

export const Logo = (props: HTMLChakraProps<'svg'>) => (
  <chakra.svg
    viewBox="0 0 1000 270"
    style={{ enableBackground: 'new 0 0 1000 270' }}
    x="0px"
    y="0px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path fill="#F0F0F0" d="M285.4,102.6h34.4c6.9,0,12.7,2,17.2,6.1s6.8,9,6.8,14.9c0,3.6-1,6.8-3,9.7c-2,2.9-4.3,4.9-6.9,5.8v0.1
        c3.8,1.1,7,3.4,9.8,7.1c2.8,3.7,4.1,7.6,4.1,11.6c0,7-2.4,12.8-7.1,17.3c-4.8,4.5-11.8,6.7-21.2,6.7h-34.2V102.6z M304.4,133.5
        h11.4c2.6,0,4.7-0.7,6.3-2.1c1.7-1.4,2.5-3.2,2.5-5.4c0-2.2-0.8-4-2.5-5.4c-1.7-1.4-3.8-2.1-6.3-2.1h-11.4V133.5z M304.4,165.9
        h13.2c3.1,0,5.6-0.8,7.5-2.5s2.8-3.8,2.8-6.4c0-2.7-1-4.9-2.9-6.5c-1.9-1.6-4.4-2.4-7.4-2.4h-13.2L304.4,165.9L304.4,165.9z"/>
      <path fill="#F0F0F0" d="M411.1,181.8l-4.5-12.4h-31.4l-4.5,12.4h-20.5l31.7-79.2h18l31.7,79.2H411.1z M381.3,152.8h19.1l-5.7-15.4
        c-0.5-1.3-1-2.9-1.6-4.9c-0.6-2-1.1-3.6-1.5-4.9l-0.7-1.8h-0.1l-0.6,1.8c-0.5,1.3-1,2.9-1.6,4.9c-0.6,2-1.2,3.6-1.6,4.9
        L381.3,152.8z"/>
      <path fill="#F0F0F0" d="M483.1,102.6h19v44c0,11.7-3.2,20.8-9.5,27.2c-6.3,6.4-14.8,9.6-25.5,9.6c-10.7,0-19.2-3.2-25.5-9.6
        c-6.3-6.4-9.5-15.5-9.5-27.2v-44h19v43.6c0,13,5.3,19.5,16,19.5c10.6,0,16-6.5,16-19.5L483.1,102.6L483.1,102.6z"/>
      <path fill="#F0F0F0" d="M588.7,181.8h-22.4l-24-32.9l-6.7,6.7v26.3h-19v-79.2h19v12.9c0,3.8,0,7.1-0.1,10s-0.1,4.8-0.2,5.6v1.4h0.1
        l0.8-0.9c0.6-0.6,1.8-1.8,3.5-3.6c1.7-1.8,3.8-3.9,6.1-6.2l19.2-19.1h23.3l-33.6,33.7L588.7,181.8z"/>
      <path fill="#F0F0F0" d="M650.6,175.4h-0.1c-2.3,2.4-5.4,4.4-9.5,5.8c-4,1.5-8.1,2.2-12.1,2.2c-11.5,0-21.2-3.9-29.2-11.7
        c-8-7.8-12-17.6-12-29.5s4-21.7,12-29.5c8-7.8,17.7-11.7,29.2-11.7c7.6,0,14.6,1.9,21,5.7c6.4,3.8,11.4,8.9,15,15.4l-19.4,5.1
        c-1.8-2.3-4.2-4.1-7.3-5.4s-6.2-2-9.3-2c-6.5,0-11.7,2.1-15.5,6.2c-3.8,4.2-5.8,9.5-5.8,16.2c0,6.9,2.1,12.4,6.3,16.5
        s9.6,6.2,16.1,6.2c10.5,0,17.3-4.1,20.5-12.5v-0.1h-20.8V137h37v44.8h-16.3c0-0.7,0-1.3,0-2s0-1.2,0-1.6s0-0.8,0-1.1
        c0-0.3,0-0.6,0.1-0.8c0-0.2,0.1-0.4,0.1-0.5s0-0.3,0-0.3L650.6,175.4L650.6,175.4z"/>
      <path fill="#E41D34" d="M689.3,183.2c-2.5,0-4.6-0.9-6.3-2.6c-1.7-1.7-2.6-3.9-2.6-6.3c0-2.4,0.9-4.5,2.6-6.2c1.7-1.7,3.8-2.6,6.3-2.6
        c2.4,0,4.5,0.9,6.2,2.6c1.7,1.7,2.6,3.8,2.6,6.2c0,2.5-0.9,4.6-2.6,6.3C693.8,182.3,691.7,183.2,689.3,183.2z"/>
      <path fill="#F0F0F0" d="M778.5,181.8l-11.1-24.9h-43.6l-11.1,24.9h-4.6l35.7-79.2h3.7l35.7,79.2H778.5z M725.7,153h40l-16.3-36.6
        c-0.5-1.1-1-2.3-1.6-3.8c-0.6-1.5-1.1-2.7-1.5-3.5l-0.6-1.2h-0.1L745,109c-0.4,0.8-0.9,2-1.5,3.5c-0.6,1.5-1.1,2.8-1.6,3.8
        L725.7,153z"/>
      <path fill="#F0F0F0" d="M797,102.6h21.3c8.9,0,15.9,2.2,21,6.4c5.1,4.3,7.6,10.3,7.6,17.9s-2.5,13.6-7.6,17.9
        c-5.1,4.3-12.1,6.5-21,6.5h-17v30.6H797L797,102.6L797,102.6z M801.3,147.2h17c7.8,0,13.8-1.8,18-5.4c4.2-3.6,6.3-8.6,6.3-14.9
        c0-6.5-2.2-11.5-6.5-14.9s-10.2-5.2-17.8-5.2h-17V147.2z"/>
      <path fill="#F0F0F0" d="M862.1,102.6h21.3c8.9,0,15.9,2.2,21,6.4c5.1,4.3,7.6,10.3,7.6,17.9s-2.5,13.6-7.6,17.9
        c-5.1,4.3-12.1,6.5-21,6.5h-17v30.6h-4.3L862.1,102.6L862.1,102.6z M866.4,147.2h17c7.8,0,13.8-1.8,18-5.4
        c4.2-3.6,6.3-8.6,6.3-14.9c0-6.5-2.2-11.5-6.5-14.9s-10.2-5.2-17.8-5.2h-17V147.2z"/>
    </g>
    <g>
      <g>
        <polygon fill="#E41D34" points="173.4,140.9 143.9,111.5 128.1,127.3 173.4,172.6 266.2,79.9 250.3,64.1 		"/>
      </g>
    </g>
    <g>
      <path fill="#F0F0F0" d="M233.7,124.1c0.6,3.6,1,7.2,1,10.9c0,34.4-28,62.4-62.4,62.4s-62.4-28-62.4-62.4s28-62.4,62.4-62.4
        c16,0,30.6,6.1,41.7,16l15.6-15.6c-15.1-14-35.2-22.5-57.3-22.5c-46.6,0-84.5,37.9-84.5,84.5s37.9,84.5,84.5,84.5
        s84.5-37.9,84.5-84.5c0-10.2-1.8-19.9-5.1-28.9L233.7,124.1z"/>
    </g>
  </chakra.svg>
)
